export default {
  data() {
    return {
      tables: {
        headers: [
          { text: 'Номер продажи', value: 'id', align: 'center', sortable: false },
          { text: 'Статус', value: 'status', align: 'center', sortable: false },
          { text: 'Бонусы', value: 'bonuses', align: 'center', sortable: false },
          { text: 'Дата создания', value: 'created_at', align: 'center', sortable: false },
          { text: 'Дата обновления', value: 'updated_at', align: 'center', sortable: false },
          { text: 'Действия', value: 'actions', align: 'center', sortable: false },
        ],
        subHeaders: [
          { text: 'Номер позиции', value: 'id', align: 'center' },
          { text: 'Изделие', value: 'product', align: 'center', sortable: false },
          { text: 'Бонусы', value: 'bonuses', align: 'center' },
          { text: '', value: '', align: 'center' },

        ],
      },
      history: [],
      showHistoryID: false,
      editStatuses: ['adminReview', 'draft', 'redo'],
      /** Filter */
      filterCreatedAt: null,
      filterUpdatedAt: null,
      showCreatedAt: false,
      showUpdatedAt: false,
      loadFilter: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    sales() {
      return this.$store.state.sales.sales;
    },
    loading() {
      return this.$store.state.loading;
    },
    filteredData() {
      let items = this.sales;
      if (this.filterCreatedAt) {
        items = items.filter(
          el => el.created_at && el.created_at.includes(this.filterCreatedAt),
        );
      }
      if (this.filterSoldOn) {
        items = items.filter(
          el => el.sold_on_local && el.sold_on_local.includes(this.filterSoldOn),
        );
      }
      if (this.filterFnsNumber) {
        items = items.filter(
          el => el.fns_number && el.fns_number.includes(this.filterFnsNumber),
        );
      }
      if (this.filterId) {
        items = items.filter(el => el.id && el.id.toString().includes(this.filterId));
      }
      if (this.filterStatuses && this.filterStatuses.length) {
        items = items.filter(
          el => el.status_label && this.filterStatuses.includes(el.status_label),
        );
      }
      if (this.filterDamagesTypes && this.filterDamagesTypes.length) {
        items = items.filter(
          el => el.damage_type && this.filterDamagesTypes.includes(el.damage_type),
        );
      }
      if (this.filterExpertReses && this.filterExpertReses.length) {
        items = items.filter(
          el => el.expert_res && this.filterExpertReses.includes(el.expert_res),
        );
      }
      return items;
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    filterCreatedAt(val) {
      this.filter();
    },
    // eslint-disable-next-line no-unused-vars
    filterUpdatedAt(val) {
      this.filter();
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    filter() {
      this.loadFilter = true;
      this.$store.dispatch('sales/GetSalesList', {
        profile_id: this.user.profile_id,
        created_at: this.filterCreatedAt,
        updated_at: this.filterUpdatedAt,

      }).finally(() => {
        setTimeout(() => { this.loadFilter = false; }, 1200);
      });
    },
    isEdit(status) {
      return this.editStatuses.indexOf(status) > -1;
    },

    getSaleQuantity(id) {
      const sale = this.sales.filter(item => item.id === id);
      let quantity = 0;
      if (sale[0].positions) {
        quantity = sale[0].positions.reduce((acc1, d1) => {
          acc1 += d1.quantity;
          return acc1;
        }, 0);
      }
      return quantity;
    },
    getSaleBonuses(id) {
      const sale = this.sales.filter(item => item.id === id);
      let bonuses = 0;
      if (sale[0].positions) {
        bonuses = sale[0].positions.reduce((acc1, d1) => {
          acc1 += d1.bonuses;
          return acc1;
        }, 0);
      }
      return bonuses;
    },
    addSale(id, actionId) {
      this.$router.push(`/sale/${actionId}/${id}`);
    },
    showHistory(id) {
      const sale = this.sales.filter(item => item.id === id);
      this.history = sale.length ? sale[0].history : [];
      this.showHistoryID = (this.showHistoryID !== id) ? id : false;
    },
    getStatusColor(item) {
      switch (item.status) {
        case 'adminReview': return 'color-orange';
        case 'draft': return 'color-white';

        case 'declined': return 'color-red';
        case 'redo': return 'color-red';
        case 'pay_error': return 'color-red';

        case 'approved': return 'color-green';
        case 'paid': return 'color-green';
        case 'paid_in_n_days': return 'color-green';

        default: return '';
      }
    },
  },
  mounted() {
    this.$store.dispatch('sales/GetSalesList', { profile_id: this.user.profile_id });
    // this.$store.dispatch('sales/GetProductsList');
  },
};
